/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as GirisRouteImport } from './routes/giris'
import { Route as IndirmelerRouteImport } from './routes/indirmeler'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAyarlarRouteImport } from './routes/_authed/ayarlar'
import { Route as AuthedDenetimRouteImport } from './routes/_authed/denetim'
import { Route as AuthedLisanslarRouteImport } from './routes/_authed/lisanslar'
import { Route as AuthedMusterilerRouteImport } from './routes/_authed/musteriler'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const GirisRoute = GirisRouteImport.update({
  id: '/giris',
  path: '/giris',
  getParentRoute: () => rootRouteImport,
} as any)
const IndirmelerRoute = IndirmelerRouteImport.update({
  id: '/indirmeler',
  path: '/indirmeler',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAyarlarRoute = AuthedAyarlarRouteImport.update({
  id: '/ayarlar',
  path: '/ayarlar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDenetimRoute = AuthedDenetimRouteImport.update({
  id: '/denetim',
  path: '/denetim',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLisanslarRoute = AuthedLisanslarRouteImport.update({
  id: '/lisanslar',
  path: '/lisanslar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMusterilerRoute = AuthedMusterilerRouteImport.update({
  id: '/musteriler',
  path: '/musteriler',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/giris': typeof GirisRoute
  '/indirmeler': typeof IndirmelerRoute
  '/ayarlar': typeof AuthedAyarlarRoute
  '/denetim': typeof AuthedDenetimRoute
  '/lisanslar': typeof AuthedLisanslarRoute
  '/musteriler': typeof AuthedMusterilerRoute
}
export interface FileRoutesByTo {
  '/giris': typeof GirisRoute
  '/indirmeler': typeof IndirmelerRoute
  '/ayarlar': typeof AuthedAyarlarRoute
  '/denetim': typeof AuthedDenetimRoute
  '/lisanslar': typeof AuthedLisanslarRoute
  '/musteriler': typeof AuthedMusterilerRoute
  '/': typeof AuthedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/giris': typeof GirisRoute
  '/indirmeler': typeof IndirmelerRoute
  '/_authed/ayarlar': typeof AuthedAyarlarRoute
  '/_authed/denetim': typeof AuthedDenetimRoute
  '/_authed/lisanslar': typeof AuthedLisanslarRoute
  '/_authed/musteriler': typeof AuthedMusterilerRoute
  '/_authed/': typeof AuthedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/giris'
    | '/indirmeler'
    | '/ayarlar'
    | '/denetim'
    | '/lisanslar'
    | '/musteriler'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/giris'
    | '/indirmeler'
    | '/ayarlar'
    | '/denetim'
    | '/lisanslar'
    | '/musteriler'
    | '/'
  id:
    | '__root__'
    | '/_authed'
    | '/giris'
    | '/indirmeler'
    | '/_authed/ayarlar'
    | '/_authed/denetim'
    | '/_authed/lisanslar'
    | '/_authed/musteriler'
    | '/_authed/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  GirisRoute: typeof GirisRoute
  IndirmelerRoute: typeof IndirmelerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/giris': {
      id: '/giris'
      path: '/giris'
      fullPath: '/giris'
      preLoaderRoute: typeof GirisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/indirmeler': {
      id: '/indirmeler'
      path: '/indirmeler'
      fullPath: '/indirmeler'
      preLoaderRoute: typeof IndirmelerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ayarlar': {
      id: '/_authed/ayarlar'
      path: '/ayarlar'
      fullPath: '/ayarlar'
      preLoaderRoute: typeof AuthedAyarlarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/denetim': {
      id: '/_authed/denetim'
      path: '/denetim'
      fullPath: '/denetim'
      preLoaderRoute: typeof AuthedDenetimRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/lisanslar': {
      id: '/_authed/lisanslar'
      path: '/lisanslar'
      fullPath: '/lisanslar'
      preLoaderRoute: typeof AuthedLisanslarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/musteriler': {
      id: '/_authed/musteriler'
      path: '/musteriler'
      fullPath: '/musteriler'
      preLoaderRoute: typeof AuthedMusterilerRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAyarlarRoute: typeof AuthedAyarlarRoute
  AuthedDenetimRoute: typeof AuthedDenetimRoute
  AuthedLisanslarRoute: typeof AuthedLisanslarRoute
  AuthedMusterilerRoute: typeof AuthedMusterilerRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAyarlarRoute: AuthedAyarlarRoute,
  AuthedDenetimRoute: AuthedDenetimRoute,
  AuthedLisanslarRoute: AuthedLisanslarRoute,
  AuthedMusterilerRoute: AuthedMusterilerRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  GirisRoute: GirisRoute,
  IndirmelerRoute: IndirmelerRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
